import dayjs from 'dayjs';

export function isNearExpiry(
  expiryDate: dayjs.ConfigType,
  minutesBeforeExpiry = 5
) {
  const minutesUntilExpiry = dayjs(expiryDate).diff(dayjs(), 'minutes');
  return minutesUntilExpiry < minutesBeforeExpiry;
}
